/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Defaultsla_Label1Inputs */

const en_cases_settings_defaultsla_label1 = /** @type {(inputs: Cases_Settings_Defaultsla_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default SLA (hours)`)
};

/**
* | output |
* | --- |
* | "Default SLA (hours)" |
*
* @param {Cases_Settings_Defaultsla_Label1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_defaultsla_label1 = /** @type {((inputs?: Cases_Settings_Defaultsla_Label1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Defaultsla_Label1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_defaultsla_label1(inputs)
});
export { cases_settings_defaultsla_label1 as "cases_settings_defaultSla_label" }